// extracted by mini-css-extract-plugin
module.exports = {"label":"ImageDetails_label__1SkIt","description":"ImageDetails_description__2kZLY","btn":"ImageDetails_btn__YMiuD"};